/**
 * Dependency Injection Module: Dashboard
 * Configures inversify container for dashboard feature
 */

import { Container } from 'inversify';

import { DashboardApiService } from '../data/remote/service/DashboardAPIService';
import { DashboardRepositoryImpl } from '../data/repository/DashboardRepositoryImpl';
import type { IDashboardRepository } from '../domain/repository/IDashboardRepository';

const TYPES = {
  IDashboardRepository: Symbol.for('IDashboardRepository'),
};

const container = new Container();

container
  .bind<IDashboardRepository>(TYPES.IDashboardRepository)
  .to(DashboardRepositoryImpl)
  .inSingletonScope();

container.bind(DashboardApiService).toSelf().inSingletonScope();

export { container, TYPES };

